$mol_icon_flash $mol_icon path \M7,2V13H10V22L17,10H13L17,2H7Z
